// extracted by mini-css-extract-plugin
export default {"studySection":"styles_studySection__NRDgW","consentBorder":"styles_consentBorder__gV7Mz","sectionTitle":"styles_sectionTitle__EmEsf"};